import { useEffect, useState } from "react";
import { useLenis } from "../hooks/useLenis";
import { api } from "../lib/api";
import Nav from "../components/site/Nav";
import Hero from "../components/site/Hero";
import BrandMarquee from "../components/site/Marquee";
import Courses from "../components/site/Courses";
import Manifesto from "../components/site/Manifesto";
import Instructor from "../components/site/Instructor";
import Footer from "../components/site/Footer";

export default function Landing() {
  useLenis();
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    api.get("/courses").then((r) => setCourses(r.data.courses)).catch(() => {});
  }, []);

  return (
    <div className="bg-brand-bg text-brand-ink overflow-x-clip">
      <Nav />
      <Hero />
      <BrandMarquee />
      <Courses courses={courses} />
      <Manifesto />
      <Instructor />
      <Footer />
    </div>
  );
}
